export type BannersAction = 
  | { type: 'SET_BANNERS_CONTENT', banners: Julius.Content.StartPage }
  | { type: 'SET_FETCH_BANNERS_FAILED' }
  | { type: 'SET_IS_FETCHING_BANNERS' };

export const setContent = (banners: Julius.Content.StartPage): BannersAction => ({
  banners,
  type: 'SET_BANNERS_CONTENT',
});

export const setFetchFailed = (): BannersAction => ({
  type: 'SET_FETCH_BANNERS_FAILED',
});

export const setIsFetching = (): BannersAction => ({
  type: 'SET_IS_FETCHING_BANNERS',
});


// WEBPACK FOOTER //
// ./src/store/Banners/actions.tsx